import {RenderModal} from "../Functions/RenderModal";
import PageLoadedQueue from "../PageLoadedQueue";
import { BootboxStatic } from 'bootbox';
import $ from 'jquery';

/**
 * Add a product to a user list and create a new list
 */
class UserList {

    protected clickedArticle: string = null;
    protected clickedCreateUrl: string = null;
    protected clickedAddUrl: string = null;
    protected userListModal: HTMLElement = null;
    protected modal: BootboxStatic = null;

    constructor() {
        this.userListModal = document.querySelector('#add-to-user-list-modal');

        if (this.userListModal instanceof Element) {
            this.initEventListeners();
        }
    }

    /**
     * Open the user-list modal if the user clicks the "add to list" button
     *
     * @param e {Event}
     */
    protected openUserList = (e: Event) => {
        const target = (e.target as HTMLElement).closest('.open-user-list-btn') as HTMLElement;

        if (target) {
            this.clickedArticle = target.dataset.sku;
            this.clickedCreateUrl = target.dataset.createUrl;
            this.clickedAddUrl = target.dataset.addUrl;

            const content = this.userListModal.innerHTML;
            this.modal = RenderModal.init('', content);
        }
    }

    /**
     * Send asynchronous request
     *
     * @param url
     * @param data
     */
    protected sendRequest = async (url: string, data: {}) => {
        return await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Fehler beim absenden! - 1699967249');
                }

                return response.json();
            })
            .then(responseData => {
                if (responseData['success'] === true) {
                    this.modal.modal('hide');
                    this.modal = RenderModal.init('', responseData.successMessage);
                }
            });
    }

    /**
     * Save the product to a user-list
     *
     * @param e {Event}
     */
    protected addToUserList = (e: Event) => {
        const target = (e.target as HTMLElement).closest('.add-to-user-list-btn') as HTMLElement;

        if (target) {
            const selectedList = target
                .closest('.add-to-user-list-modal__left')
                ?.querySelector('select')
                ?.value;

            const addUrl = this.clickedAddUrl ?? this.userListModal.dataset.addUrl;
            const product = this.userListModal.dataset.product;
            const originList = this.userListModal.dataset.originList;

            const data = {
                listIdentifier: selectedList,
                articleIdentifier: this.clickedArticle,
                productIdentifier: product,
                originListIdentifier: originList
            }

            const errorMessage = document.querySelector('.bootbox .add-to-user-list-modal__error-message .alert-danger');
            if (errorMessage) {
                errorMessage.classList.add('d-none');
            }

            this.sendRequest(addUrl, data)
                .catch((error) => {
                    if (errorMessage) {
                        errorMessage.classList.remove('d-none');
                    }

                    console.error('Fehler beim absenden (1699967277):', error)
                });
        }
    }

    /**
     * create a new user list
     *
     * @param e {Event}
     */
    protected createUserList = (e: Event) => {
        const target = (e.target as HTMLElement).closest('.create-user-list-btn') as HTMLElement;

        if (target) {
            const listName = target
                .closest('.add-to-user-list-modal__right')
                ?.querySelector('input')
                ?.value;

            if (listName?.length < 1) {
                return false;
            }

            const createUrl = this.clickedCreateUrl ?? this.userListModal.dataset.createUrl;
            const product = this.userListModal.dataset.product;
            const originList = this.userListModal.dataset.originList;

            const data = {
                listName: listName,
                articleIdentifier: this.clickedArticle,
                productIdentifier: product,
                originListIdentifier: originList
            }

            const errorMessage = document.querySelector('.bootbox .add-to-user-list-modal__error-message .alert-danger');
            if (errorMessage) {
                errorMessage.classList.add('d-none');
            }

            this.sendRequest(createUrl, data)
                .catch((error) => {
                    if (errorMessage) {
                        errorMessage.classList.remove('d-none');
                    }

                    console.error('Fehler beim absenden (1699967256):', error)
                });
        }
    }

    /**
     * Initialize the event listeners
     */
    protected initEventListeners = () => {
        // open modal
        document.body.addEventListener('click', this.openUserList, {passive: true});
        document.body.addEventListener('touchend', this.openUserList, {passive: true});

        // save product to list
        document.body.addEventListener('click', this.addToUserList, {passive: true});
        document.body.addEventListener('touchend', this.addToUserList, {passive: true});

        // create a new list and add product
        document.body.addEventListener('click', this.createUserList, {passive: true});
        document.body.addEventListener('touchend', this.createUserList, {passive: true});
    }
}

PageLoadedQueue.addFunction(() => {
    new UserList();
});
